function IconAntifraudeAnalise(props) {
  return (
    <svg 
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={props.width ? props.width : '25'}
    height={props.height ? props.height : '25'}
    fill="none"
    style={{ paddingRight: props.paddingRight }}
    >
      <path 
        fill={props.color ? props.color : '#FFA806'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7z"
      />
    </svg>

  );
}

export default IconAntifraudeAnalise;
